import { VehicleStateOfChargeSummaryResponseStoreModel } from '@domain/multi-site-dashboard/multi-site-dashboard.models';

import {
  VehicleSocSummaryDayCellViewModel,
  VehicleStateOfChargeSummaryMovablePanelViewModel,
} from '../vehicle-state-of-charge-summary-movable-panel.view-model';

const emptyCell = (date: string): VehicleSocSummaryDayCellViewModel => ({ date, fullyChargedCount: 0, notFullyChargedCount: 0 });

// Builds the table view model. The day columns are the union of every site's outcome dates (ascending),
// so the header and every row stay aligned even if a site is missing a day; each row's outcomes are
// looked up by date and any gap renders as a zero cell.
export const buildVehicleSocSummaryViewModel = (
  summary: VehicleStateOfChargeSummaryResponseStoreModel
): VehicleStateOfChargeSummaryMovablePanelViewModel => {
  const days = [
    ...new Set(summary.vehicleStateOfChargeSummary.flatMap((site) => site.chargingOutcome.map((outcome) => outcome.date))),
  ].sort();

  return {
    days,
    sites: summary.vehicleStateOfChargeSummary.map((site) => {
      const outcomeByDate = new Map(site.chargingOutcome.map((outcome) => [outcome.date, outcome]));

      return {
        siteId: site.siteId,
        siteName: site.siteName,
        cells: days.map((date) => {
          const outcome = outcomeByDate.get(date);
          return outcome
            ? { date, fullyChargedCount: outcome.fullyChargedCount, notFullyChargedCount: outcome.notFullyChargedCount }
            : emptyCell(date);
        }),
      };
    }),
  };
};
